/**
 * Created by Karol Kluska on 14.12.17.
 */
/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('ConfigHotel', ConfigHotel);

function ConfigHotel() {
  var config = {};

  function setConfig(hotelConfig) {
    config = hotelConfig;
  }

  function getFinalBookingAcceptanceTime() {
    var acceptanceTime = config.final_booking_acceptance_time || '';
    return acceptanceTime.slice(11, 16) || null;
  }

  function getCheckInTime() {
    return config.check_in_time || null;
  }

  function getCheckOutTime() {
    return config.check_out_time || null;
  }

  function getPropertyType() {
    return config.property_type || 0;
  }

  function getHotel() {
    return config.hotel || {};
  }

  function getHotelName() {
    var hotel = getHotel();
    return hotel.name || null;
  }

  function getHotelPhone() {
    var hotel = getHotel();
    return hotel.phone || null;
  }

  function getCompany() {
    var hotel = getHotel();
    return hotel.company || {};
  }

  function getCompanyName() {
    var company = getCompany();
    return company.name || null;
  }

  function getTimezone() {
    return config.timezone || null;
  }

  function getTime() {
    var time = config.time.slice(0, -5);
    return new Date(time) || new Date();
  }

  return {
    setConfig: setConfig,
    getFinalBookingAcceptanceTime: getFinalBookingAcceptanceTime,
    getCheckInTime: getCheckInTime,
    getCheckOutTime: getCheckOutTime,
    getPropertyType: getPropertyType,
    getHotel: getHotel,
    getHotelName: getHotelName,
    getHotelPhone: getHotelPhone,
    getCompany: getCompany,
    getCompanyName: getCompanyName,
    getTimezone: getTimezone,
    getTime: getTime
  };
}
